export default __webpack_public_path__ + "static/media/SAS Alert Tone 4.76c9b911.mp3";